import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import _get from "lodash/get";
import nets from 'nets';
import { createAsyncAction } from "./utils";
var NERDWALLET_API_BASE_URL = process.env.NERDWALLET_API_BASE_URL;
export var getCurrentMortgageRates = createAsyncAction('getCurrentMortgageRates', function () {
  return {
    makeRequest: function makeRequest() {
      return new Promise(function (resolve, reject) {
        nets({
          method: 'GET',
          url: "".concat(NERDWALLET_API_BASE_URL, "/homeownership/v1/mortgage-rates/current?client_id=").concat(process.env.CLIENT_ID),
          encoding: 'utf8',
          timeout: 10000
        }, function (err, res, data) {
          if (_get(res, 'statusCode') === 200) {
            resolve(data);
          } else {
            reject(err);
          }
        });
      });
    }
  };
});